<!-- 项目信息 -->
<template>
  <div>
    <k-form-build
      :value="jsonData"
      ref="KFB"
    />
  </div>
</template>
<script>
export default {
  name: 'ProjectSponsor',
  data() {
    return {
      jsonData: {
        'list': [
          {
            'type': 'input',
            'icon': 'icon-edit',
            'options': {
              'width': '100%',
              'minRows': 4,
              'maxRows': 6,
              'maxLength': null,
              'defaultValue': '',
              'clearable': false,
              'hidden': false,

              'placeholder': '主要研究者'
            },
            'model': '7966d214-f16d-8a12-c59d-569d73b6c2a6',
            'key': '7966d214-f16d-8a12-c59d-569d73b6c2a6',
            'rules': [
              {
                'required': false,
                'message': '必填项'
              }
            ]
          }
        ],
        'config': {
          'layout': 'vertical',
          'labelCol': {
            'span': 4
          },
          'wrapperCol': {
            'span': 18
          },
          'hideRequiredMark': false,
          'customStyle': ''
        }
      }
    }
  },
  methods: {},
  mounted() {

  }
}
</script>
